import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { PetService } from './pet.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private petService: PetService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean  | Observable<boolean> {
    // Check if user is authenticated
    if (!this.petService.isLoggedIn()) {
      console.log(`AuthenticationGuard, not logged in`);
      this.router.navigate(["/login"]); // Redirect to login page
      return false;
    }

    // Check if token is valid (not expired)
    if (this.petService.isTokenExpired()) {
      console.log(`AuthenticationGuard, token expired`);
      localStorage.removeItem('token_expiration');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('id');
      localStorage.removeItem('user_type');
      this.router.navigate(["/login"]);
      return false;
    }

    // Check if user has the required permission
    const requiredPermission = route.data["permission"]; // Get required permission from route
    console.log(`requiredPermission: ${requiredPermission}`);
    if (requiredPermission && !this.petService.hasPermission(requiredPermission)) {
      console.log(`Not have permission: {requiredPermission}, redirect to login`);
      this.router.navigate(["/login"]); // Redirect if no permission
      return false;
    }

    // if (this.petService.isLoggedIn() && !this.petService.isTokenExpired()) {
    //   return true;
    // }
    // localStorage.removeItem('token_expiration');
    // localStorage.removeItem('access_token');
    // localStorage.removeItem('refresh_token');
    // localStorage.removeItem('id');
    // localStorage.removeItem('user_type');
    // this.router.navigate(['login'], { replaceUrl: true });
    
    return true;
  }

}
